<template>
  <span id="indicator-unknown" />
</template>
